import {sendServerRequest} from './baseService';

export const menuService = {
    getMenus,
};

async function getMenus() {
    return sendServerRequest('GET', `/api/menus`);
}
